export default __webpack_public_path__ + "static/media/IconDesc_copper_new.256.556535af.png";